import 'css-chunk:src/components/form-fields/switch-component/switch-component.module.scss';export default {
  "switch-component": "switch-component_switch-component__RvZ3o",
  "slider": "switch-component_slider__-b46G",
  "label-text": "switch-component_label-text__zF5gF"
};